import { render, staticRenderFns } from "./in_warehouse_add.vue?vue&type=template&id=a4a073d6&scoped=true&"
import script from "./in_warehouse_add.vue?vue&type=script&lang=js&"
export * from "./in_warehouse_add.vue?vue&type=script&lang=js&"
import style0 from "./in_warehouse_add.vue?vue&type=style&index=0&id=a4a073d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a073d6",
  null
  
)

export default component.exports